// extracted by mini-css-extract-plugin
export default {"wrapper":"MediaBlock_wrapper__SK83p","noRatio":"MediaBlock_noRatio__CtZwW","media":"MediaBlock_media__KM+Z3","info":"MediaBlock_info__wn2VQ"};